import React from "react";
import { ATTACHMENT_FIELD_STYLES } from "./styles";

interface ValidationErrorDisplayProps {
  errors: string[];
}

const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = ({
  errors
}) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div style={ATTACHMENT_FIELD_STYLES.errorContainer}>
      {errors.map((error, index) => (
        <div key={index} style={ATTACHMENT_FIELD_STYLES.errorItem}>
          ⚠️ {error}
        </div>
      ))}
    </div>
  );
};

export default ValidationErrorDisplay;
